import headerFunc from './common/_header';
import initViewport from './common/_viewport';
import initSmoothScroll from './common/_common';
import initArticleSliders from './project/_top';
import initCases from './project/_cases';
import initDiverParts from './project/_diver-parts';

// viewport切り替えは描画前にできるだけ早く適用したいので即時実行
initViewport();

addEventListener('DOMContentLoaded', () => {
    headerFunc();
    initArticleSliders();
    initCases();
    initDiverParts();
    initSmoothScroll();
});
